/*jshint esversion: 6 */
import React, {Component} from 'react';
import './footer.css';
import {Row, Col, Image, Typography} from 'antd';
import { MailOutlined, PhoneOutlined, HomeOutlined } from '@ant-design/icons';
import logo from "../../utils/logo-vr.png";
import Texts from "../../utils/Text";


const { Text } = Typography;

export default class Footer extends Component {
    state = {
        activeTab: window.location.pathname,
        isMobile: window.screen.width < 769,
        isOpenMenu: false,
    };

    updateIsMobile  = () => {
        this.setState({
            isMobile: window.screen.width < 769
        });
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateIsMobile);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateIsMobile);
    }
    render() {
        return (
            <div className="footer-form">
                <Row className="montserrat" justify="center" style={{ alignItems: 'center'}}>
                    {this.state.isMobile ?
                        <>
                            <Row justify="center" style={{width: '100%'}}>
                                <Image preview={false} src={logo} width={'180px'} height={'55px'}/>
                            </Row>
                            <Row style={{width: '100%'}}>
                                <Col span={24} style={{textAlign: 'center'}}>
                                    <Text style={{color: 'white'}}>{Texts('contacts', 'footer')}</Text>
                                </Col>
                            </Row>
                            <Row style={{width: '100%', margin: '8px 0px'}}>
                                <Col span={12} style={{textAlign: 'center'}}>
                                    <PhoneOutlined style={{marginRight: 10, paddingTop: '5px'}}/>
                                    <a href="tel:+77712558001">
                                        <Text style={{color: 'white'}}>{Texts('contacts', 'phone')}</Text>
                                    </a>
                                </Col>
                                <Col span={12} style={{textAlign: 'center'}}>
                                    <MailOutlined style={{marginRight: 10, paddingTop: '5px'}}/>
                                    <a href="mailto:info@vrglobal.kz">
                                        <Text style={{color: 'white'}}>
                                            {Texts('contacts', 'email')}
                                        </Text>
                                    </a>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} style={{textAlign: 'center'}}>
                                    <HomeOutlined />
                                    <Text style={{color: 'white', marginLeft: 10}}>{Texts('contacts', 'address')}</Text>
                                </Col>
                            </Row>
                        </>
                        :
                        <>
                            <Col span={5} style={{width: '203px', textAlign: 'center'}}>
                                <Image preview={false} src={logo} width={'180px'} height={'55px'}/>
                            </Col>
                            <Col span={5} style={{textAlign: 'center'}}>
                                <Text style={{color: 'white'}}>{Texts('contacts', 'footer')}</Text>
                            </Col>
                            <Col span={4} style={{textAlign: 'center'}}>
                                <PhoneOutlined style={{marginRight: 10, paddingTop: '5px'}}/>
                                <a href="tel:+77712558001">
                                    <Text style={{color: 'white'}}>{Texts('contacts', 'phone')}</Text>
                                </a>
                            </Col>
                            <Col span={5} style={{textAlign: 'center'}}>
                                <MailOutlined style={{marginRight: 10, paddingTop: '5px'}}/>
                                <a href="mailto:info@vrglobal.kz">
                                    <Text style={{color: 'white'}}>
                                        {Texts('contacts', 'email')}
                                    </Text>
                                </a>
                            </Col>
                            <Col span={5} style={{textAlign: 'center'}}>
                                <HomeOutlined />
                                <Text style={{color: 'white', marginLeft: 10}}>{Texts('contacts', 'address')}</Text>
                            </Col>
                        </>
                    }
                </Row>
            </div>
        );
    }
};
